<template>
  <div class="w-[100lvw] h-[100lvh] flex flex-col items-center relative">
    <div class="absolute inset-0 z-10 overflow-hidden">
      <BaseSpiral class="min-w-[1300px] min-h-[900px] heightMd:min-h-full heightMd:min-w-full w-full h-full" :stroke-color="strokeColor" />
    </div>

    <div class="relative z-10 flex flex-col items-center w-full h-full justify-center">
      <div>
        <h1 class="heightMd:text-[44px] text-[60px] font-bold text-white">Awesome</h1>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import BaseSpiral from '@/components/base/BaseSpiral.vue'
import { useSound } from '@/composables/useSound'

const { strokeColor } = defineProps<{ strokeColor: string }>()

const { playWordFormed } = useSound()

onMounted(() => {
  playWordFormed()
})
</script>
